module.exports = __webpack_public_path__ + "static/media/prevClimatica.bf6c5ed2.gif";